import { useAuthorization } from 'components/Authorization';
import { authShopFlag, AuthShopOpenMode } from 'services/api/flagr';
import { authOpenModeCache } from 'services/cache';

const defaultOpenMode: AuthShopOpenMode = 'external';

const platformABTestEnable: Record<General.Platform, boolean> = {
  shopee: false,
  lazada: false,
  tiktok: true,
  tokopedia: false,
  aliexpress: false,
};

const useAuthOpenMode = () => {
  const { payload } = useAuthorization<Oversea.Token.Payload>();

  async function get(platform: General.Platform) {
    if (!platformABTestEnable[platform]) return defaultOpenMode;

    const mode = authOpenModeCache.get<AuthShopOpenMode>();
    if (mode) {
      // eslint-disable-next-line no-console
      console.log('openMode from cache: ', mode);
      return mode;
    }
    try {
      const res = await authShopFlag(payload!.orgId);
      const { openMode } = res || {};
      if (openMode) {
        authOpenModeCache.set(openMode);
        // eslint-disable-next-line no-console
        console.log('openMode from flagr: ', openMode);
        return openMode;
      }
      // eslint-disable-next-line no-console
      console.log('openMode from default: ', defaultOpenMode);
      return defaultOpenMode;
    } catch (err) {
      // eslint-disable-next-line no-console
      console.log('openMode from error: ', defaultOpenMode);
      return defaultOpenMode;
    }
  }

  return get;
};

export default useAuthOpenMode;
